<template>
  <b-row align-h="between" align-v="end" class="the-detail__head">
    <b-col>
      <h1>User</h1>
    </b-col>
    <b-col cols="auto">
      <span v-on:click="closeDetailPage" class="the-detail__head__windowcloser"><img src="images/icon/sitedetail/closer.svg" alt="Close Detailview"/></span>
    </b-col>
  </b-row>
</template>

<script>

import { mapState, mapMutations } from 'vuex'

export default {
  name: 'UserDetailBreadcrumb',

  computed: {

    ...mapState('user', [
      'userDetail'
    ]),

    name () {
      let company = this.userDetail.data.a_company

      if ((this.userDetail.data.firstname.length + this.userDetail.data.lastname.length + company.length) > 0) {
        if (company.length > 0 && (this.userDetail.data.firstname.length + this.userDetail.data.lastname.length) > 0) {
          company = company + ':'
        }
        return [company, this.userDetail.data.firstname, this.userDetail.data.lastname].join(' ')
      }

      return 'N.N'
    }
  },

  methods: {

    ...mapMutations('user', [
      'closeDetailPage'
    ])
  }
}
</script>
